import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatBankAccount } from "@edaz/utils/bankAccount";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import { emptyValue } from "utils/emptyValue";
import { formatAmount, formatDate, translateEnum } from "utils/localizations";
import type CustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/customerRefundCandidates/customerRefundCandidateDetailViewModel";
import type RejectedCustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/rejectedCustomerRefundCandidates/rejectedCustomerRefundCandidateDetailViewModel";
import Section from "views/common/section";

const OriginalTransferPaymentSection: ViewComponent<
  CustomerRefundCandidateDetailViewModel | RejectedCustomerRefundCandidateDetailViewModel
> = observer(({ vm }) => {
  const originalPayment = vm.item.originalTransferPayment;

  return (
    <Section title={vm.translate("originalPayment")} context={vm.item.originalTransferPayment}>
      <Form.Row>
        <Form.Group as={Col} xs={12}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidateTransferPaymentResponse", "senderName")}</Form.Label>
          <FakeInput target={originalPayment} property="senderName" />
        </Form.Group>
        <Form.Group as={Col} xs={12}>
          <Form.Label>
            {vm.translateSubAttribute("customerRefundCandidateTransferPaymentResponse", "senderBankAccount")}
          </Form.Label>
          <FakeInput target={originalPayment} property="senderBankAccount" valueFormatter={formatBankAccount} />
        </Form.Group>
        <Form.Group as={Col} lg={6}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidateTransferPaymentResponse", "variableSymbol")}</Form.Label>
          <FakeInput target={originalPayment} property="variableSymbol" />
        </Form.Group>
        <Form.Group as={Col} lg={6} xl={3}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidateTransferPaymentResponse", "constantSymbol")}</Form.Label>
          <FakeInput target={originalPayment} property="constantSymbol" />
        </Form.Group>
        <Form.Group as={Col} lg={6} xl={3}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidateTransferPaymentResponse", "specificSymbol")}</Form.Label>
          <FakeInput target={originalPayment} property="specificSymbol" />
        </Form.Group>
        <Form.Group as={Col} lg={6}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidateTransferPaymentResponse", "transferType")}</Form.Label>
          <FakeInput
            target={originalPayment}
            property="transferType"
            valueFormatter={value => (value ? translateEnum("transferType", value) : emptyValue)}
          />
        </Form.Group>
        <Form.Group as={Col} lg={6} xl={3}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidateTransferPaymentResponse", "postingDate")}</Form.Label>
          <FakeInput target={originalPayment} property="postingDate" valueFormatter={formatDate} />
        </Form.Group>
        <Form.Group as={Col} lg={6} xl={3}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidateTransferPaymentResponse", "paidAmount")}</Form.Label>
          <FakeInput target={originalPayment} property="paidAmount" valueFormatter={formatAmount} />
        </Form.Group>
        <Form.Group as={Col} xs={12}>
          <Form.Label>
            {vm.translateSubAttribute("customerRefundCandidateTransferPaymentResponse", "additionalInformation")}
          </Form.Label>
          <FakeInput target={originalPayment} property="additionalInformation" />
        </Form.Group>
        <Form.Group as={Col} xs={12}>
          <Form.Label>
            {vm.translateSubAttribute("customerRefundCandidateTransferPaymentResponse", "messageForRecipient")}
          </Form.Label>
          <FakeInput target={originalPayment} property="messageForRecipient" />
        </Form.Group>
        <Form.Group as={Col} xs={12}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidateTransferPaymentResponse", "senderAddress")}</Form.Label>
          <FakeInput target={originalPayment} property="senderAddress" />
        </Form.Group>
        <Form.Group as={Col} lg={6}>
          <Form.Label>
            {vm.translateSubAttribute("customerRefundCandidateTransferPaymentResponse", "bankTransactionId")}
          </Form.Label>
          <FakeInput target={originalPayment} property="bankTransactionId" />
        </Form.Group>
        <Form.Group as={Col} lg={6}>
          <Form.Label>
            {vm.translateSubAttribute("customerRefundCandidateTransferPaymentResponse", "externalBankTransactionId")}
          </Form.Label>
          <FakeInput target={originalPayment} property="externalBankTransactionId" />
        </Form.Group>
      </Form.Row>
    </Section>
  );
});

export default OriginalTransferPaymentSection;
